import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard, Thumbs } from 'swiper/modules';
import { useState } from 'react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';
import CustomModal from './CustomModal';

const SliderModal = ({ photos, description, title, triggerRef }) => {
	const [thumbsSwiper, setThumbsSwiper] = useState(null);
	const [activeIndex, setActiveIndex] = useState(0);

	return (
		<CustomModal.Wrapper
			className="photo-slider-modal"
			animation="fade"
			closeBtnOuter={true}
			modalBtn={
				<button
					ref={triggerRef}
					className="hidden"
					aria-label="Open photo gallery"
				/>
			}
		>
			<div className="w-full max-w-[90vw] lg:max-w-[1200px] mx-auto">
				{/* Title and Counter */}
				<div className="flex items-center justify-between mb-4 flex-wrap gap-2">
					{title && (
						<h3 className="text-white text-[20px] md:text-[28px] font-medium">
							{title}
						</h3>
					)}
					<div className="text-white text-[14px] md:text-[16px] bg-black bg-opacity-50 px-4 py-2 rounded-full">
						{activeIndex + 1} / {photos?.length || 0}
					</div>
				</div>

				{/* Main Slider */}
				<Swiper
					modules={[Navigation, Pagination, Keyboard, Thumbs]}
					navigation={true}
					pagination={{
						clickable: true,
						dynamicBullets: true,
					}}
					keyboard={{ enabled: true }}
					thumbs={{
						swiper:
							thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
					}}
					spaceBetween={30}
					slidesPerView={1}
					onSlideChange={swiper => setActiveIndex(swiper.activeIndex)}
					className="photo-slider-main mb-4"
				>
					{photos?.map((photo, index) => (
						<SwiperSlide key={index}>
							<div className="flex items-center justify-center h-full">
								<div className="relative w-full max-h-[60vh] flex items-center justify-center bg-black bg-opacity-30 rounded-lg p-4">
									<img
										src={`https://kera.enfonoerp.com/${photo?.image}`}
										alt={`${title || 'Photo'} ${index + 1}`}
										className="max-w-full max-h-[60vh] object-contain rounded-lg shadow-2xl"
									/>
								</div>
							</div>
						</SwiperSlide>
					))}
				</Swiper>

				{/* Thumbnail Slider */}
				{photos && photos.length > 1 && (
					<Swiper
						modules={[Thumbs]}
						onSwiper={setThumbsSwiper}
						spaceBetween={10}
						slidesPerView="auto"
						watchSlidesProgress
						className="photo-slider-thumbs mt-4"
					>
						{photos?.map((photo, index) => (
							<SwiperSlide
								key={index}
								className="!w-[80px] !h-[80px] cursor-pointer"
							>
								<div className="relative w-full h-full">
									<img
										src={`https://kera.enfonoerp.com/${photo?.image}`}
										alt={`Thumbnail ${index + 1}`}
										className="w-full h-full object-cover rounded-md"
									/>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
				)}

				{/* Single Description */}
				{description && (
					<div className="bg-white bg-opacity-95 p-4 md:p-6 rounded-lg max-w-[800px] mx-auto mt-6">
						<div className="flex items-start gap-3">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-6 w-6 text-[#146084] flex-shrink-0 mt-1"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
								/>
							</svg>
							<p className="text-[14px] md:text-[16px] text-[#333] leading-relaxed">
								{description}
							</p>
						</div>
					</div>
				)}
			</div>
		</CustomModal.Wrapper>
	);
};

export default SliderModal;
